import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
export class InventoryEntryDetailModel {
  inventoryEntryDetailId: number = 0;
  inventoryEntryId: number = 0;
  inventoryEntry: InventoryEntryModel | null = null;
  storeId: number = 0;
  articleId: number = 0;
  unitValue: number = 0;
  discount: number = 0;
  iva: number = 0;
  quantity: number = 0;
  totalValue: number = 0;
  purchaseOrderDetailId: number | null = null;
  inventoryEntryDetailOriginId: number | null = null;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
